export default {
    url: '/level',
    template: '<user-group-list-level/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/group/list/level/index.js